import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Enregistrement du service worker (PWA : installation + offline du shell). Uniquement en
// production — même garde que sip-rouleau-scan, pour ne pas interférer avec le hot-reload de
// `npm start`.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch((err) => {
      console.error('Échec de l’enregistrement du service worker :', err);
    });
  });
}
